import script from "./MiNTNewsListPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsListPreview.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsListPreview.vue?vue&type=style&index=0&id=ebc750b0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebc750b0"]])

export default __exports__